import cx from 'classnames'
import Section from 'components/common/Section'
import { SectionHeader } from './SectionHeader'
import { Marketing } from 'designsystem/Text'
import { Button } from 'designsystem/Button'
import Link from 'next/link'
import { useUserContext } from 'components/UserProvider'
import { useRouter } from 'next/router'
import { InputForm } from './InputForm'

interface CTASectionProps extends React.HTMLAttributes<HTMLElement> {
  title: string
  subline: string
  withinSection?: boolean
  theme?: 'light' | 'dark'
}

export const CTASection = ({
  title,
  subline,
  withinSection,
  theme,
}: CTASectionProps): JSX.Element | null => {
  const { user } = useUserContext()
  const router = useRouter()

  const inputFormData = {
    placeholder: 'Your API endpoint...',
    buttonText: 'Get started',
    customOnSubmit: (url) => {
      router.push({
        pathname: '/signup',
        query: {
          redirect: `/app/onboarding?origin=${encodeURIComponent(url)}`,
        },
      })
    },
  }

  if (withinSection && user) {
    return null
  }

  if (withinSection) {
    return (
      <div className='spacer-2xl flex flex-col space-y-12 sm:items-center lg:flex-row lg:space-y-0 lg:space-x-20 justify-between'>
        <header className='flex-grow text-left sm:text-center lg:text-left'>
          <Marketing.H3 className={cx(theme === 'dark' && 'text-white')}>
            {title}
          </Marketing.H3>
          <Marketing.SubHeadline
            className={cx(
              'spacer-3xs max-w-lg !text-left sm:!text-center lg:!text-left !mx-0',
              theme === 'dark' && '!text-neutral-on-dark-60',
            )}
          >
            {subline}
          </Marketing.SubHeadline>
        </header>
        <InputForm
          {...inputFormData}
          theme={theme}
          className='w-full !justify-end'
        />
      </div>
    )
  }

  return (
    <Section
      bgColor='white'
      verticalPadding='xs'
      className='max-w-768 mx-auto text-left sm:text-center'
    >
      <SectionHeader title={title} subline={subline} paddingToContent='small' />
      {user ? (
        <Link href='/app'>
          <Button pageType='marketing'>Go to dashboard</Button>
        </Link>
      ) : (
        <InputForm {...inputFormData} theme={theme} />
      )}
    </Section>
  )
}
